import * as Website from '../../Config/Website.js';
import * as Accordion from './Modules/Accordion.js';


const preinit = () => {

}

const init = () => {
  Accordion.init();
}

const pageChanged = () => {
  Accordion.init();
}

const resize = () => {
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}